import { render } from "./EpkHeader.vue?vue&type=template&id=88f78a42"
const script = {}

import "./EpkHeader.vue?vue&type=style&index=0&id=88f78a42&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__